import { Icon, Spinner } from '@blueprintjs/core';
import { ShowHide } from 'components/layout';
import { useDebounce } from 'hooks/useDebounce';
import React, { useCallback, useEffect, useState } from 'react';
import { AssetService } from 'services';

const debounceTimeout = 250;

export function TemplateBuilderAssetLookupPreview(props) {

    const value = props.answer?.answer ?? '';

    const [searchValue, setSearchValue] = useState("");
    const debouncedValue = useDebounce(searchValue, debounceTimeout);

    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);

    const searchAndListAssets = useCallback(async ({ searchTerm, id }) => {
        const itemsToList = [];
        try {

            setIsLoading(true);

            if (searchTerm) {

                const assetsRequest = {
                    searchTerm,
                    pageNumber: 1,
                    filters: []
                }

                const result = await AssetService.searchAssets(assetsRequest);

                result?.data?.forEach(item => {
                    itemsToList.push({
                        id: item.assetId,
                        name: item.assetRegistration
                    });
                });
            }
            if (id) {
                const result = await AssetService.getAsset(id);
                result && itemsToList.push({
                    id: result.assetId,
                    name: result.registration
                });
            }

        } finally {
            setOptions(itemsToList);
            setIsLoading(false);
        }
    }, []);

    const handleSelect = useCallback((id) => {

        const updatedAnswer = {
            ...props.answer,
            answer: id,
            isAnswered: true,
        }

        if (value === id) {
            updatedAnswer.answer = "";
        }

        setOptions([...options.filter(o => o.id === updatedAnswer.answer)]);
        setSearchValue("");
        props.onChange?.(updatedAnswer);
    }, [options]);

    useEffect(() => {
        if (debouncedValue.length < 2) {
            return;
        }
        searchAndListAssets({ searchTerm: debouncedValue });
    }, [debouncedValue]);

    useEffect(() => {
        if (value && !options.find(o => o.id === value)) {
            searchAndListAssets({ id: value });
        }
    }, []);

    return (
        <div className="check-preview-form-field">
            {!value && (
                <div style={{ marginBottom: '10px' }}>
                    <input type='search' placeholder='Search for an asset...' value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                </div>
            )}
            <ShowHide evaluator={isLoading}
                show={<Spinner size={25} />}
            />
            <div className="check-preview-input-container">
                <div className="multi-select">
                    {options.map(option => (
                        <button
                            key={option.id}
                            className={`bp6-button bp6-large btn-form multi-select-option ${value === option.id ? 'active' : ''}`}
                            onClick={() => handleSelect(option.id)}
                        >
                            <span className="bp6-button-text">{option.name}</span>
                            <Icon icon="tick" />
                        </button>
                    ))}
                </div>
                {props.deleteComponent}
            </div>
            {props.addAnotherComponent}
        </div>
    );
}